import moment from "moment";
import CustomChip from "../../../core/custom-chip";
import { convertToCamelCaseFromUnderScore } from "../../../utils";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { STATE_LIST } from "../../../utils/state-list";
export const HeaderConfig = [
  {
    label: "Ticket ID",
    id: "id",
    onClick: true,
    render: (data, onClick) => {
      return (
        <span className="clickable" onClick={() => onClick(data)}>
          {data?.id}
        </span>
      );
    },
  },
  {
    label: "Created On",
    id: "createdAt",
    render: (data) => {
      return (
        <span>
          {data?.createdAt && moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
          {data?.createdAt && new Date(data?.createdAt).toLocaleTimeString()}
        </span>
      );
    },
  },
  {
    label: "Created By",
    id: "createdBy",
    render: (data) => {
      return <span>{data?.createdBy?.name}</span>;
    },
  },
  {
    label: "OEM",
    id: "oem",
    render: (data) => {
      return <span>{data?.oem?.name}</span>;
    },
  },
  {
    label: "Engine Serial Number",
    id: "engineNo",
  },
  {
    label: "Complaint Description",
    id: "customerComplaintCode",
    render: (data) => {
      return <span>{data?.customerComplaintCode?.description}</span>;
    },
  },
  {
    label: "List Number",
    id: "listNumber",
  },
  {
    label: "Engine Approved By",
    id: "approvedBy",
  },
  {
    label: "Engine Approved Date",
    id: "engineReplacementApprovedDate",
  },
  {
    label: "Engine Replacement Status",
    id: "engineReplacementStatus",
    render: (data) => {
      return (
        <span>
          {
            FLOAT_ENGINE_STATUS?.find(
              (ele) => ele?.value === data?.engineReplacementStatus
            )?.label
          }
        </span>
      );
    },
  },
  {
    label: "Ticket Status",
    id: "status",
    render: (data) => {
      const value = getStatus(data);
      return (
        <CustomChip
          label={value}
          colorKey={
            value === "Resolved"
              ? "green"
              : value === "Open"
              ? "orange"
              : "blue"
          }
        />
      );
    },
  },
];

export const getStatus = (data) => {
  const { underWarranty, status, serviceEngineer, dateOfInspection } = data;
  // if (
  //   status === "OPENED" &&
  //   underWarranty &&
  //   serviceEngineer &&
  //   dateOfInspection
  // ) {
  //   return "JI Date fixed";
  // } else if (status === "OPENED" && underWarranty && serviceEngineer) {
  //   return "Engineer Assigned";
  // } else if (status === "OPENED" && underWarranty) {
  //   return "Acknowledged";
  // } else if (status === "OPENED") {
  //   return "Open";
  // } else {
  //   return convertToCamelCaseFromUnderScore(status);
  // }
  if (status === "OPENED") {
    return "Open";
  } else if (status === "REOPENED") {
    return "Reopen";
  } else {
    return convertToCamelCaseFromUnderScore(status);
  }
};
export const FLOAT_ENGINE_DISPATCHED_MODE = [
  { label: "From Simpson", value: "SIMPSON" },
  { label: "From DEPOT", value: "DEPOT" },
  { label: "From OEM", value: "OEM" },
];
export const ENGINE_TYPE = [
  {
    label: "Float Engine",
    value: "FLOAT",
  },
  {
    label: "New Engine",
    value: "NEW",
  },
];
export const ENGINE_PHYSICAL_STATUS = [
  { label: "Under Rework", value: "UNDER_REWORK" },
  { label: "In Testing", value: "IN_TESTING" },
  { label: "In Painting", value: "IN_PAINTING" },
  { label: "In EFD", value: "IN_EFD" },
  { label: "Need to Pack", value: "NEED_TO_PACK" },
  { label: "Boxed", value: "BOXED" },
];
export const APPROVED_MODE_OPTIONS = [
  { label: "In Warranty", value: "IN_WARRANTY" },
  { label: "Out Of Warranty", value: "OUT_OF_WARRANTY" },
];
export const FLOAT_ENGINE_STATUS = [
  { label: "Yet to dispatch", value: "YET_TO_DISPATCH" },
  { label: "Engine Dispatched", value: "ENGINE_DISPATCHED" },
];
export const floatEngineFormConfig = [
  {
    label: "Complaint Engine Invoice Number",
    type: "text",
    name: "invoiceNumber",
    placeholder: "Engine Invoice Number",
  },
  {
    label: "Complaint Engine Invoice Date",
    type: "datePicker",
    name: "invoiceDate",
    placeholder: "Engine Invoice Number",
  },
  {
    label: "List Number",
    type: "text",
    name: "listNumber",
    placeholder: "List Number",
  },
  {
    label: "Plant",
    type: "text",
    name: "plant",
    placeholder: "Plant",
  },
  {
    label: "Stock Engine Physical Status",
    type: "text",
    name: "enginePhysicalStatus",
    placeholder: "Engine Physical Status",
  },
  {
    label: "Engine Approved Mode",
    type: "text",
    name: "engineApprovedMode",
    placeholder: "Approved Mode",
  },
];
export const floatEngineActionConfig = [
  {
    label: "Float Engine Dispatched Mode",
    type: "autocomplete",
    name: "floatEngineDispatchedMode",
    options: FLOAT_ENGINE_DISPATCHED_MODE,
    placeholder: "Float Engine Dispatched Mode",
    required: true,
  },
  {
    label: "Replacement Engine Number",
    type: "text",
    name: "replacementEngineNumber",
    placeholder: "Replacement Engine Number",
    required: true,
  },
  {
    label: "Replacement Engine Delivery Challan Number",
    type: "text",
    name: "replacementEngineDeliveryChallanNumber",
    placeholder: "Replacement Engine Delivery Challan Number",
    required: true,
  },
  {
    label: "Replacement Engine Delivery Challan Date",
    type: "datePicker",
    name: "replacementEngineDeliveryChallanDate",
    placeholder: "Replacement Engine Delivery Challan Date",
    required: true,
  },

  {
    label: "Invoice Values",
    type: "text",
    name: "invoiceValues",
    placeholder: "Invoice Values",
    required: true,
  },
  {
    label: "Invoice Tax Values",
    type: "text",
    name: "invoiceTaxValue",
    placeholder: "Invoice Tax Values",
    required: true,
  },
  // {
  //   label: "List Number",
  //   type: "text",
  //   name: "listNumber",
  //   placeholder: "List Number ",
  // },
  // {
  //   label: "Plant",
  //   type: "text",
  //   name: "plant",
  //   placeholder: "Plant",
  // },
  {
    label: "Reference Number",
    type: "text",
    name: "referenceNumber",
    placeholder: "Reference Number",
    required: true,
  },
  {
    label: "Transporter",
    type: "text",
    name: "transporter",
    placeholder: "Transporter",
    required: true,
  },
  {
    label: "Docket Number",
    type: "text",
    name: "docketNumber",
    placeholder: "Docket Number",
    required: true,
  },
  {
    label: "Docket Date",
    type: "datePicker",
    name: "docketDate",
    placeholder: "Docket Date",
    required: true,
  },
  {
    label: "Engine Dispatch Location",
    type: "text",
    name: "engineDispatchLocation",
    placeholder: "Engine Dispatch Location",
    required: true,
  },
  {
    label: "State",
    name: "state",
    type: "autocomplete",
    options: STATE_LIST,
    required: true,
    placeholder: "State",
  },
  {
    label: "FOC Receipt Date",
    type: "datePicker",
    name: "focReceiptDate",
    placeholder: "FOC Receipt Date",
    required: true,
  },
  {
    label: "OEM Org",
    type: "text",
    name: "oem",
    placeholder: "OEM",
    disabled: true,
  },
  {
    label: "Engine Type",
    type: "autocomplete",
    name: "engineType",
    placeholder: "Engine Type",
    options: ENGINE_TYPE,
    required: true,
  },
  {
    label: "Engine Replacement Cost",
    type: "number",
    name: "engineReplacementCost",
    placeholder: "Engine Replacement Cost",
    required: true,
  },
  {
    label: "Dispatch Status",
    type: "autocomplete",
    name: "status",
    placeholder: "Select Dispatch Status",
    options: FLOAT_ENGINE_STATUS,
    required: true,
  },
  {
    label: "Add comment",
    type: "textarea",
    name: "comment",
    placeholder: "Add comments",
    fieldGridSize: 12,
  },
];
export const generateFOCPDF = (data) => {
  const doc = new jsPDF();
  const pageHeight = doc.internal.pageSize.height; // Height of the page
  let currentY = 20; // Starting Y position

  const addPageIfNeeded = (requiredHeight) => {
    if (currentY + requiredHeight > pageHeight - 20) {
      doc.addPage();
      currentY = 20; // Reset Y position for new page
    }
  };

  // Helper function to render signatures
  const renderSignature = (label, signature, x, y) => {
    doc.setFontSize(12);
    doc.text(label, x, y);

    if (signature) {
      try {
        // Check if the signature is a valid image URL (e.g., a link to a hosted image)
        doc.addImage(signature, x, y + 5, 40, 20);
      } catch (error) {
        console.warn(`${label} has an invalid format:`, error.message);
        doc.text("Invalid", x + 50, y + 12); // Show "Invalid" if the image format is invalid
      }
    } else {
      doc.text("N/A", x + 50, y + 12); // Show "N/A" if no signature is provided
    }
  };

  // Title
  doc.setFontSize(18);
  doc.text("FOC Report", 14, currentY);
  currentY += 10;

  // Add basic info as a table
  const basicInfoFields = data.focFields.map(([key, value]) => [
    key,
    value || "N/A",
  ]);

  autoTable(doc, {
    head: [["Field", "Value"]],
    body: basicInfoFields,
    startY: currentY,
  });

  currentY = doc.lastAutoTable.finalY + 10;

  // Render "Details Of Observation"
  const additionalInfo = Object.fromEntries(data.additionalInfoFields);

  // Format and render "Service Maintenance Record"
  if (additionalInfo["Service Maintenance Record"]?.length > 0) {
    const serviceRecords = additionalInfo["Service Maintenance Record"].map(
      (ele) => [
        ele?.serviceNo,
        moment(ele?.date).format("DD-MM-YYYY"), // Format date
        ele?.hours,
      ]
    );

    addPageIfNeeded(20); // Check for space
    doc.setFontSize(14);
    doc.text("Service Maintenance Record", 14, currentY);

    autoTable(doc, {
      head: [["Service No", "Date", "Hours"]],
      body: serviceRecords,
      startY: currentY + 6,
    });

    currentY = doc.lastAutoTable.finalY + 10; // Update current Y position
  }

  // Format and render "Past Complaints"
  if (additionalInfo["Past Complaints"]?.length > 0) {
    const pastComplaints = additionalInfo["Past Complaints"].map((ele) => [
      moment(ele?.date).format("DD-MM-YYYY"), // Format date
      ele.hours,
      ele.complaintReported,
    ]);

    addPageIfNeeded(20); // Check for space
    doc.setFontSize(14);
    doc.text("Past Complaints", 14, currentY);

    autoTable(doc, {
      head: [["Date", "Hours", "Complaint Reported"]],
      body: pastComplaints,
      startY: currentY + 6,
    });

    currentY = doc.lastAutoTable.finalY + 10; // Update current Y position
  }

  // Render signatures
  const oemSignature = additionalInfo["Oem Sign"] || null; // Base64 or null

  addPageIfNeeded(60); // Ensure space for signatures
  doc.setFontSize(14);
  doc.text("Signatures", 14, currentY);
  currentY += 10;

  renderSignature("OEM Signature:", oemSignature, 14, currentY);
  currentY += 30;

  currentY += 30;

  // Save PDF
  doc.save(`FOC_Report.pdf`);
};
export const TICKET_FORM1 = (ticketDetails, complaintForm) => [
  {
    label: "Next Action",
    value: convertToCamelCaseFromUnderScore(ticketDetails.stage) || "-",
  },
];
export const TICKET_FORM2 = (ticketDetails, complaintForm) => [
  {
    label: "Replacement Approved",
    value:
      (ticketDetails.engineReplacementApprovedDate &&
        moment(ticketDetails.engineReplacementApprovedDate).format(
          "DD/MM/YYYY"
        )) ||
      "-",
  },
  // {
  //   label: "Dispatch Status",
  //   value: "Yet to dispatch",
  // },
  {
    label: "Defective Engine Serial Number",
    value: complaintForm.engineSerialNumber || "-",
  },
  { label: "State", value: complaintForm.oemEngineLocation?.state || "-" },
];
export const TICKET_FORM3 = (ticketDetails, complaintForm) => [
  {
    label: "Repaired",
    value: "-",
  },
  {
    label: "Defective",
    value: "-",
  },
];
